/* src/app/main/pages/apps/container-specification/container-specification.component.css */
.app-img {
  width: 65px;
  height: 65px;
}
.back-link {
  color: #E8882D;
  font-family: "D-DIN";
  font-size: 16px;
}
.back-link .fa-angle-left {
  font-weight: 600;
}
.apps-form-input {
  background-color: #213654;
  padding: 8px 10px;
  margin-top: 30px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 6px #00000029;
}
.apps-form-input label,
.apps-form-result label {
  width: 83%;
  margin-bottom: 0px;
  font-weight: 600;
}
.apps-form-input .form-control,
.apps-form-result .form-control {
  font-size: 15px;
  height: auto;
  border-radius: 0;
  padding: 3px 10px;
  border: none;
}
.apps-form-result {
  background-color: #E6E6E6;
  padding: 8px 10px;
  margin-top: 30px;
  margin-bottom: 15px;
}
.bg-gray {
  background-color: #F5F5F5;
  box-shadow: 0px 3px 6px #00000029;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #E3EFFF;
}
tbody {
  background-color: #fff;
}
.table th,
.table td {
  padding: 8px 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  font-weight: 400;
}
.border-after::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
  top: 0;
  right: 15px;
}
@media (max-width: 355px) {
  .container-specification .table th,
  .container-specification .table td {
    font-size: 12px !important;
    padding: 8px 10px;
  }
}
@media (max-width: 767px) {
  .apps-form-input label,
  .apps-form-result label {
    width: 100%;
    font-size: 12px;
  }
  .apps-form-input .form-control,
  .apps-form-result .form-control {
    font-size: 13px;
  }
  .apps-form-result {
    margin-top: 10px;
  }
  .container-specification .table th,
  .container-specification .table td {
    font-size: 13px;
  }
  .border-after::after {
    content: none;
  }
  .result-heading {
    font-size: 16px;
  }
  .result-value {
    font-size: 15px;
  }
  .card-img-top {
    margin-top: 10px;
  }
  .container-specification .back-link {
    margin-bottom: 5px;
  }
  .apps-form-input {
    padding: 15px 10px;
  }
}
@media (device-width: 768px) {
  .container-specification .border-right {
    border-right: none !important;
  }
}
@media (max-width: 768px) {
  .sm-border-none {
    border-right: none !important;
  }
}
@media (device-width: 1024px) {
  .apps-form-input label,
  .apps-form-result label {
    width: 100%;
  }
  .result-value {
    font-size: 13px;
  }
  .border-after::after {
    right: 16px;
  }
}
@media (device-width: 1200px) {
  .border-after::after {
    right: 13px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .apps-form-input label,
  .apps-form-result label {
    width: 95%;
    font-size: 17px;
  }
  .apps-form-input .form-control,
  .apps-form-result .form-control {
    font-size: 16px;
  }
  .table th,
  .table td {
    font-size: 19px;
  }
  .container-specification .result-heading {
    font-size: 19px;
  }
  .container-specification .result-value {
    font-size: 16px;
  }
}
@media (min-width: 1440px) {
  .back-link {
    font-size: 24px !important;
  }
}
@media (min-width: 1600px) {
  .apps-form-input label,
  .apps-form-result label {
    font-size: 18px;
    width: 100%;
  }
  .apps-form-input .form-control,
  .apps-form-result .form-control {
    font-size: 16px;
    padding: 6px 10px;
  }
  .back-link {
    font-size: 24px;
  }
  .container-specification .table th,
  .container-specification .table td {
    font-size: 20px;
  }
  .result-heading {
    font-size: 21px;
  }
  .result-value {
    font-size: 20px;
  }
}
.loader {
  position: absolute;
  background-color: #cccccc6e;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
}
.loader-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: auto;
  text-align: center;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
.containerSpecificationDetails {
  position: relative;
}
@-moz-document url-prefix() {
  .apps-form-input .form-control {
    width: 60%;
  }
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=container-specification.component.css.map */
